import { clsx } from 'clsx'
import { type FC, useEffect } from 'react'

import { useDeviceDetectorContext } from '../../../device-detector'
import { ExperimentFreeGiftPromotion } from '../../../experiments/components/ExperimentFreeGiftPromotion/ExperimentFreeGiftPromotion'
import { useIsfreeGiftPromotionsExperimentEnabledAndV2 } from '../../../experiments/components/ExperimentFreeGiftPromotion/useGetFreeGiftPromotionsExperiment'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import { useRemovePacksizesExperimentActivation } from '../../../experiments/remove-variants-for-expa-experiment/useRemovePacksizesExperimentActivation'
import { useRemovePacksizesExperimentShouldHideVariants } from '../../../experiments/remove-variants-for-expa-experiment/useRemoveVariantsExperimentShouldHideVariantsForExpa'
import { productAccessorIsSaeOffer } from '../../model/productAccessor/productAccessorIsSaeOffer'
import { ProductPageAttributesSelection } from '../ProductPageAttributesSelection'
import { ProductPageContactLensesInfoNotification } from '../ProductPageContactLensesInfoNotification/ProductPageContactLensesInfoNotification'
import { useProductPageContext } from '../productPageContext'

import { ProductAddToCartGroup } from './ProductAddToCartGroup'
import { ProductBuyBoxNowDetails } from './ProductBuyBoxNowDetails'
import {
  ProductPageMobileRadioStyleAttributesSelection,
  ProductPageSingleAttributesHeader,
  ProductPageSingleAttributesHeaderLabels,
} from './ProductPageSingleAttributes'
import { ProductVariantHeader } from './ProductVariantHeader'

export const ProductBuyBoxCom: FC = () => {
  const { attributeSelectionControls, currentOffer } = useProductPageContext()
  const { hasSingleRenderGroup } = attributeSelectionControls
  const { addExperimentKeysForActivation } = useExperimentsContext()

  const showOnlyOnDesktopClassName = clsx(
    hasSingleRenderGroup && 'hidden tablet:block',
  )

  const isMarketplace = currentOffer
    ? !productAccessorIsSaeOffer(currentOffer)
    : false

  const showOnlyOnMobileClassName = clsx(
    hasSingleRenderGroup && 'tablet:hidden',
  )
  const { isMobile } = useDeviceDetectorContext()
  const isFreeGiftPromotionsExperimentEnabledAndV2 =
    useIsfreeGiftPromotionsExperimentEnabledAndV2(isMobile)

  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  useRemovePacksizesExperimentActivation()
  const shouldHideVariantsForRemovePackSizeExperiment =
    useRemovePacksizesExperimentShouldHideVariants()

  useEffect(() => {
    if (pdpDeliveryOptions.isEnabled) {
      addExperimentKeysForActivation(pdpDeliveryOptions.name)
    }
  }, [addExperimentKeysForActivation, pdpDeliveryOptions])

  return (
    <div className="mb-5 w-full">
      {hasSingleRenderGroup ? (
        <div className={showOnlyOnMobileClassName}>
          <ProductPageSingleAttributesHeaderLabels />
        </div>
      ) : null}
      <div className="w-full rounded-2xl bg-light-primary-medium px-4 pb-2.5 pt-5">
        <div className={showOnlyOnDesktopClassName}>
          <ProductVariantHeader />
        </div>
        {/* on mobile case single we do not show "normal" attribute selection but "old school one" */}
        {hasSingleRenderGroup ? (
          <div className={showOnlyOnMobileClassName}>
            <ProductPageSingleAttributesHeader />
          </div>
        ) : null}
        {hasSingleRenderGroup &&
        shouldHideVariantsForRemovePackSizeExperiment ? null : (
          <div className={showOnlyOnDesktopClassName}>
            <ProductPageAttributesSelection />
          </div>
        )}
        {(pdpDeliveryOptions.isEnabled &&
          (pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V1 ||
            pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V3 ||
            pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.DEFAULT)) ||
        !pdpDeliveryOptions.isEnabled ||
        isMarketplace ? (
          <>
            <ProductBuyBoxNowDetails />
            <ProductAddToCartGroup />
          </>
        ) : (
          <>
            <ProductAddToCartGroup />
            <ProductBuyBoxNowDetails />
          </>
        )}
        <ProductPageContactLensesInfoNotification />
        {/* on mobile case single we do not show "normal" attribute selection but "old school one" */}
        {hasSingleRenderGroup &&
        !shouldHideVariantsForRemovePackSizeExperiment ? (
          <ProductPageMobileRadioStyleAttributesSelection
            className={showOnlyOnMobileClassName}
          />
        ) : null}
        {isFreeGiftPromotionsExperimentEnabledAndV2 ? (
          <ExperimentFreeGiftPromotion isMobile={isMobile} />
        ) : null}
      </div>
    </div>
  )
}
